
import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    
    primary: {
      main: '#7d7d7dff',          
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f44336',
    },

   
    neutral: {
      main: grey[800],
      contrastText: '#ffffff',
    },
  },
  components: {
    
    MuiButton: {
      defaultProps: {
        variant: 'contained',   
        color: 'primary',       
      },
      styleOverrides: {
        containedPrimary: {
          borderRadius: 10,
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;